module.exports = __webpack_public_path__ + "static/img/weixin.a4c935b3.png";